import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { getHomeUrlByRole, isUserCabinetRole } from '@core/enums/entry-url.enum';

import { ErrorModel } from '@core/api';

import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { RequestIdService } from '../../services/request-id.service';
import {OrderService} from "@accounts/user/services/order.service";

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  titleText = this.i18n('Вход в профиль');
  btnText = this.i18n('Продолжить');

  errors = null;
  returnUrl = null;
  loading = false;

  constructor(
    public form: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private requestIdService: RequestIdService,
    private i18n: I18n,
    private orderService: OrderService
  ) {
  }

  ngOnInit() {
    // reset login status
    this.authService.reset();
    this.requestIdService.reset();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;
  }

  submit(value) {
    this.loading = true;

    this.authService.loginByPassword(value.phone, value.password, value.rememberMe)
      .pipe(finalize(() => this.loading = false))
      .subscribe(data => {
        this.redirectByRole();
      },
        (err: ErrorModel) => {
          this.errors = err;
        });
  }

  redirectByRole() {
    const guestAuthRedirect = localStorage.getItem('guestAuthRedirect');
    localStorage.removeItem('guestAuthRedirect');
    const role = this.userService.currentUserValue && this.userService.currentUserValue.role;
    if (guestAuthRedirect && isUserCabinetRole(role)) {
      this.router.navigate(JSON.parse(guestAuthRedirect));
    } else {
      document.location.href = document.location.origin + getHomeUrlByRole(role);
    }
  }
}
